export default __webpack_public_path__ + "static/media/tutorial.6b6dd26d.png";